export interface Ratios {
  sin: number;
  cos: number;
  tan: number;
  csc: number;
  sec: number;
  cot: number;
}

const ASYMPTOTE_EPS = 1e-12;

function safe(numerator: number, denominator: number): number {
  if (Math.abs(denominator) < ASYMPTOTE_EPS) {
    return numerator >= 0 ? Infinity : -Infinity;
  }
  return numerator / denominator;
}

export function ratiosFromAngle(theta: number): Ratios {
  const s = Math.sin(theta);
  const c = Math.cos(theta);
  return {
    sin: s,
    cos: c,
    tan: safe(s, c),
    csc: safe(1, s),
    sec: safe(1, c),
    cot: safe(c, s),
  };
}

export function ratiosFromPoint(x: number, y: number): Ratios {
  const len = Math.hypot(x, y);
  if (len < ASYMPTOTE_EPS) {
    return { sin: 0, cos: 1, tan: 0, csc: Infinity, sec: 1, cot: Infinity };
  }
  return ratiosFromAngle(Math.atan2(y, x));
}

const EXACT_TABLE: Array<{ value: number; label: string }> = [
  { value: 0, label: '0' },
  { value: 0.5, label: '1/2' },
  { value: Math.SQRT1_2, label: '√2/2' },
  { value: Math.sqrt(3) / 2, label: '√3/2' },
  { value: 1, label: '1' },
];

export function exactForm(v: number, epsilon = 1e-6): string | null {
  const sign = v < 0 ? '−' : '';
  const abs = Math.abs(v);
  for (const entry of EXACT_TABLE) {
    if (Math.abs(abs - entry.value) <= epsilon) {
      return sign + entry.label;
    }
  }
  return null;
}
